import {remCalc} from '_themeUtils'

const commonMobileButton = {
    flexGrow: 1,
    cursor: 'pointer',
    py: 'spacing.3',
    px: 'spacing.8',
    flexWrap: 'wrap',
    justify: 'center',
    minH: remCalc(46),
}

const wishlistButtons = {
    WishlistButtons: {
        baseStyle: () => ({
            buttons: {
                justify: {base: 'center', md: 'flex-start'},
                mt: 'spacing.5',
                mb: {md: 'spacing.4'},
                spacing: 'spacing.4',
            },
            wishlistButton: {
                w: 'fit-content',
            },
            mobileActionsWrapper: {
                w: 'full',
                pos: 'fixed',
                bottom: remCalc(-1),
                left: 0,
                zIndex: 'sticky',
                spacing: 0,
                align: 'stretch',
                transition: 'opacity 0.2s ease-in-out',
            },
            hiddenMobileActionsWrapper: {
                opacity: 0,
            },
            shareWishlistMobileButton: {
                ...commonMobileButton,
                bg: 'color.background.grey.200',
            },
            buyAllProductsMobileButton: {
                ...commonMobileButton,
                bg: 'color.background.white',
            },
            mobileButtonText: {
                textStyle: 'paragraphXxs',
                letterSpacing: remCalc(3),
                fontWeight: 300,
                lineHeight: remCalc(24), // Custom line height
            },
        }),
    },
}

export default wishlistButtons
